import { useOnboarding } from '../../context/OnboardingContext';
import ElementRenderer from '../elements/ElementRenderer';

const ScreenContent = ({ opacity = 1 }) => {
    const { getCurrentScreen } = useOnboarding();

    const screen = getCurrentScreen();

    if (!screen) return null;

    const contentElements = [];
    const bottomElements = [];

    screen.elements.forEach((element, index) => {
        if (element.type === 'button' && element.position !== 'inline') {
            bottomElements.push(<ElementRenderer key={index} element={element} />);
        } else {
            contentElements.push(<ElementRenderer key={index} element={element} />);
        }
    });

    return (
        <div className="content-container" style={{ opacity }}>
            <div className="content-area">
                {contentElements}
            </div>
            {bottomElements.length > 0 && (
                <div className="bottom-section">
                    {bottomElements}
                </div>
            )}
        </div>
    );
};

export default ScreenContent;
